import React from 'react';
import ReportTemplateModel, { ReportTemplateModelNames } from './ReportTemplateModel';

const FiltersList = () => {
    return (
        <ReportTemplateModel
            modelName={ReportTemplateModelNames.Filter}
        />
    );
}
export default React.memo(FiltersList);
